import {
  ApiSlugs,
  EmailDto,
  MobileNumberDto,
  UserActionTokenEmailDto,
  UserActionTokenMobileNumberDto,
  UserActionTokenVerificationDto,
  UserTwoFADto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';

export class TokenVaultsUserConnector {
  private slug = ApiSlugs.USERS;

  constructor(
    private apiCaller: ApiCaller,
    private tokenVaultUrl: string,
    private prefix: string,
  ) {
    this.tokenVaultUrl = `${this.tokenVaultUrl}/${this.slug}`;
  }

  twoFA = () => ({
    newToken: (dto: UserTwoFADto): Observable<boolean> =>
      this.apiCaller.postRequest<boolean>(this.prefix, `${this.tokenVaultUrl}/two-fa`, dto),
    verifyToken: (verify: UserActionTokenVerificationDto): Observable<boolean> =>
      this.apiCaller.postRequest<boolean>(this.prefix, `${this.tokenVaultUrl}/two-fa/verify`, verify),
  });

  change = () => ({
    email: (dto: UserActionTokenEmailDto): Observable<EmailDto> =>
      this.apiCaller.postRequest<EmailDto>(this.prefix, `${this.tokenVaultUrl}/change-email`, dto),
    mobileNumber: (dto: UserActionTokenMobileNumberDto): Observable<MobileNumberDto> =>
      this.apiCaller.postRequest<MobileNumberDto>(
        this.prefix,
        `${this.tokenVaultUrl}/change-mobile-number`,
        dto,
      ),
  });
}
